import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Button } from '@mui/material';
import { Folder as FolderIcon, Add as AddIcon } from '@mui/icons-material';

/**
 * Component to display empty state when no tasks are available
 * @param {Object} props - Component props
 * @param {Function} props.onAddTopics - Function to add topics
 * @returns {React.ReactElement} Empty state view component
 */
const EmptyStateView = ({ onAddTopics }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        px: 3,
        backgroundColor: '#f8f8f8',
        borderRadius: 1,
        border: '1px dashed rgba(0, 0, 0, 0.12)',
        width: '100%'
      }}
    >
      <FolderIcon sx={{ fontSize: 48, color: 'text.secondary', opacity: 0.5, mb: 2 }} />
      <Typography variant="h6" sx={{ color: 'text.secondary', mb: 1 }}>
        No tasks available
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3, textAlign: 'center' }}>
        No tasks have been selected for this project yet.
      </Typography>

      {onAddTopics && (
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={onAddTopics}
          sx={{
            bgcolor: '#475969',
            '&:hover': { bgcolor: '#364554' },
            borderRadius: '8px',
            textTransform: 'none'
          }}
        >
          Add topics
        </Button>
      )}
    </Box>
  );
};

EmptyStateView.propTypes = {
  onAddTopics: PropTypes.func
};

export default React.memo(EmptyStateView);
